/* global DataTable */
// https://github.com/Mobius1/Vanilla-DataTables/wiki/Getting-Started

const databaseTable = document.querySelectorAll('[data-table="database-table"]');

const databaseTableOptions = {
  searchable: false,
  fixedHeight: false,
  perPage: 100,
  perPageSelect: false,
};

databaseTable.forEach((el) => {
  // eslint-disable-next-line no-unused-vars
  const databaseTableInit = new DataTable(el, databaseTableOptions);
});
